import React from "react";
import { Moon } from "lucide-react";

/** Pedidos registrados que el administrador aún no ha atendido. */
export const UNATTENDED_STATUSES = ["Pendiente", "Ajuste Enviado"];

export const hasUnattendedOrders = (orders) =>
  (orders || []).some((o) => UNATTENDED_STATUSES.includes(o.status));

/** Aviso exclusivo para clientes con pedidos pendientes de atención mientras la tienda
 *  está cerrada. No se muestra sin pedidos pendientes ni para pedidos ya atendidos. */
export function AdminOfflineNotice({ orders }) {
  if (!hasUnattendedOrders(orders)) return null;
  return (
    <div
      data-testid="admin-offline-notice"
      role="status"
      className="rounded-2xl border border-indigo-400/50 bg-indigo-950/50 backdrop-blur-sm p-4 sm:p-5 flex items-start gap-3 shadow-[0_0_25px_rgba(99,102,241,0.25)]"
    >
      <div className="w-10 h-10 rounded-full bg-indigo-500/20 border border-indigo-400/60 flex items-center justify-center flex-shrink-0">
        <Moon className="w-5 h-5 text-indigo-200" />
      </div>
      <p className="text-sm text-indigo-50 leading-relaxed">
        🌙 Tu pedido sigue registrado. Nuestro administrador está desconectado y atenderá tu recarga
        cuando vuelva a estar activo. No necesitas realizar otro pedido ni enviar nuevamente el pago.
      </p>
    </div>
  );
}
